// upstack_api refuses anything past these (Engagements::ScoringRequestSchemas), so the panel stops there first.
export const MAX_SCORING_INVITEES = 20;
export const INVITEE_NAME_LIMIT = 100;
export const INVITEE_EMAIL_LIMIT = 254;
export const INVITEE_ROLE_LIMIT = 100;
export const SCORING_NOTE_LIMIT = 2000;
